import { useLang } from 'hooks/lang';

import { recruitmentStatusByCode, loaders } from 'entities';

import { Button } from 'components/Blocks';

import { useUser } from 'hooks/user';

import { OnRecruitment, useRecruitmentAssign } from './context';
import { UserOwnershipBreakdown } from '../components';
import { resolveColorClass } from 'styles';

export function UserRecruitments() {
  const user = useUser();

  const { t } = useLang();

  const { openRecruitment } = useRecruitmentAssign();

  const recruitments = loaders.projects.listActiveRecruitments.use({
    defaultValue: [],
    parser: (list) => list.filter((r) => r.owner.team === user.team.id),
  });

  const onRecruitment: OnRecruitment = (recruitment): void => {
    if (recruitmentStatusByCode[recruitment.status]) return;

    recruitments.overwrite((list) =>
      list.map((rec) => (rec.id === recruitment.id ? { ...rec, ...recruitment } : rec)),
    );
  };

  return (
    <UserOwnershipBreakdown
      title={t('active-projects-per-user')!}
      statusConfig={recruitmentStatusByCode}
      loading={recruitments.loading}
      entries={recruitments.data}
      render={(recruitment) => (
        <Button
          variant="ghost"
          onClick={() => openRecruitment(recruitment.id, onRecruitment)}
          className={resolveColorClass(recruitmentStatusByCode[recruitment.status].color, 'text')}
        >
          {recruitment.sampleId}
        </Button>
      )}
    />
  );
}
